<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('ds_exam_management.progress_report_result_sheet') +' ' + $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Organization" vid="org_name_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="organiation_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.organization')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.org_id"
                                    :options="orgList"
                                    id="organiation_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :disabled="$store.state.Auth.authUser.role_id === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Type" vid="inst_type_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="inst_type_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_type')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.office_type_id"
                                    :options="officeTypeList"
                                    id="inst_type_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Name" vid="inst_name_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="inst_name_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_name')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.office_id"
                                    :options="officeList"
                                    id="inst_name_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <ValidationProvider name="Class Name" vid="class_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="class_id"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{$t('online_admission.class')}}
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.class_id"
                                        :options="classList"
                                        id="class_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <b-spinner v-if="studentSpinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                            <ValidationProvider name="Student ID" vid="student_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="student_id"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{$t('ds_student_management.student_name')}}
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.applicant_id"
                                        id="student_id"
                                        :options="studentList"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12" md="4">
                            <ValidationProvider name="Year" vid="year_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="year_id "
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('globalTrans.year')}}
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.year"
                                    id="year_id"
                                    :options="yearList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="IEP Slot" vid="slot">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="slot "
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{$t('ds_student_management.slot')}}
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.slot_id"
                                        id="slot_id"
                                        :options="IepSlotList"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                            <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('ds_exam_management.progress_report_result_sheets')  + ' ' +  $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:head(check)>
                        <b-form-checkbox
                            style="display: table-cell"
                            class="col-form-label-sm font-weight-bold mb-0"
                            name="checked"
                            v-model="selectAll"
                            @change="checkAll"
                            :value=true
                            :unchecked-value=false
                        >
                        </b-form-checkbox>
                    </template>
                    <template v-slot:cell(check)="data">
                        <!-- CheckBox -->
                        <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group v-model="selectedStudents" style="margin-top: 5px" :aria-describedby="ariaDescribedby">
                                <b-form-checkbox :value="data.item.id" style="margin-right: 0"></b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                    </template>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(year)="data">
                      {{ $n(data.item.year, { useGrouping: false }) }}
                    </template>
                    <template v-slot:cell(studentId)="data">
                      {{ $n(data.item.student.student_id, { useGrouping: false }) }}
                    </template>
                    <template v-slot:cell(status)="data">
                        <span v-if="data.item" class="badge badge-danger">{{ $t('globalTrans.not_published') }}</span>
                    </template>
                   <template v-slot:cell(action)="data">
                     <div style="width: 150px">
                         <b-button v-b-modal.modal-2 variant=" iq-bg-success mb-1" size="sm" title="Details" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>
                     </div>
                    </template>
                    <template #custom-foot="">
                        <b-tr>
                            <b-th colspan="8"></b-th>
                            <b-th colspan="2" class="text-center">
                                <button @click="publishResult()" class="btn btn-primary btn-sm blink_me" :title="$t('globalTrans.approve')" :disabled="selectedStudents.length > 0 ? false : true">
                                    <i class="fas fa-list"></i>{{ $t('globalTrans.publish') }}
                                </button>
                            </b-th>
                        </b-tr>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-2" size="xl" :title="ViewTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="viewitemId" :item="item" :key="viewitemId"/>
    </b-modal>
  </b-container>
</template>
<script>

import Details from './Details'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { progressLetterListApi, studentInfo, publishResultApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Details,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
        selectAll: false,
        selectedStudents: [],
        search: {
            year: 0,
            org_id: 0,
            office_type_id: 0,
            office_id: 0,
            class_id: 0,
            applicant_id: 0,
            slot_id: 0
        },
        viewitemId: 0,
        officeTypeList: [],
        officeList: [],
        studentSpinLoader: false,
        tmpStudentList: [],
        studentList: [],
        item: {}
    }
  },
  computed: {
    examTypeList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.examTypeList.filter(item => item.status === 1)
    },
    yearList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
            if (this.$i18n.locale === 'bn') {
                return { value: item, text: this.$n(item, { useGrouping: false }) }
            } else {
                return item
            }
        })
    },
    IepSlotList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.IepSlotList.filter(item => item.status === 1)
    },
    classList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
    },
    orgList: function () {
        return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    ViewTitle () {
       return this.$t('ds_exam_management.progress_report_result_sheets') + ' ' + this.$t('globalTrans.details') + ' ' + this.$t('sidebar.information')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: 'check', class: 'text-center' },
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('ds_student_management.year'), class: 'text-left' },
          { label: this.$t('ds_config.organization'), class: 'text-left' },
        //   { label: this.$t('ds_institute_management.institute_type'), class: 'text-left' },
          { label: this.$t('ds_institute_management.institute_name'), class: 'text-left' },
          { label: this.$t('ds_student_management.slot'), class: 'text-left' },
          { label: this.$t('online_admission.class'), class: 'text-left' },
          { label: this.$t('ds_student_management.student_roll'), class: 'text-left' },
          { label: this.$t('globalTrans.status'), class: 'text-left' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
            { key: 'check' },
            { key: 'index' },
            { key: 'year' },
            { key: 'organization_name_bn' },
            // { key: 'institute_type_name_bn' },
            { key: 'institute_name_bn' },
            { key: 'slot_bn' },
            { key: 'class_name_bn' },
            { key: 'studentId' },
            { key: 'status' },
            { key: 'action' }
        ]
      } else {
        keys = [
            { key: 'check' },
            { key: 'index' },
            { key: 'year' },
            { key: 'organization_name' },
            // { key: 'institute_type_name' },
            { key: 'institute_name' },
            { key: 'slot_en' },
            { key: 'class_name' },
            { key: 'studentId' },
            { key: 'status' },
            { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
        this.getOfficeTypeList()
        if (this.search.office_id && this.search.office_type_id && this.search.class_id) {
            this.getStudentData()
        }
    },
    'search.office_type_id': function (newVal, oldVal) {
        this.getOfficeList()
        if (this.search.org_id && this.search.office_id && this.search.class_id) {
            this.getStudentData()
        }
    },
    'search.office_id': function (newVal, oldVal) {
        if (this.search.org_id && this.search.office_type_id && this.search.class_id) {
            this.getStudentData()
        }
    },
    'search.class_id': function (newVal, oldVal) {
        this.getStudentData()
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
            }
            this.getStudentList()
        }
    },
    selectedStudents: function () {
      if (this.selectedStudents.length === this.listData.length) {
        this.selectAll = true
      }

      if (this.selectedStudents.length < this.listData.length) {
        this.selectAll = false
      }
    }
  },
  created () {
    this.search.org_id = this.$store.state.dataFilters.orgId
    this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.search.office_id = this.$store.state.dataFilters.officeId
    this.loadData()
  },
  mounted () {
  },
  methods: {
    checkAll () {
        if (this.selectAll) {
            this.selectedStudents.splice(0, this.selectedStudents.length)
            this.listData.forEach(element => this.selectedStudents.push(element.id))
        } else {
            this.selectedStudents.splice(0, this.selectedStudents.length)
        }
    },
    publishResult () {
      const myData = {
        ids: this.selectedStudents
      }
      var message = window.vm.$t('globalTrans.publishMsg')
      this.confirmationPopup(message, (response) => {
        if (response === true) {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          const loadingState = { loading: false, listReload: true }
          RestApi.postData(disabilitySchoolServiceBaseUrl, publishResultApi, myData).then(response => {
          this.$store.dispatch('mutateCommonProperties', loadingState)
            if (response.success) {
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.$t('globalTrans.update_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: this.$t('globalTrans.operationFailed')
                })
            }
          })
        }
      })
    },
    async getStudentData () {
        this.studentSpinLoader = true
        let result = null
        result = await RestApi.postData(disabilitySchoolServiceBaseUrl, studentInfo, { office_id: this.search.office_id, class_id: this.search.class_id })
        if (result.success) {
            this.studentSpinLoader = false
            this.tmpStudentList = result.data
            this.getStudentList()
        }
    },
    getStudentList () {
        this.studentList = this.tmpStudentList.map(item => {
            if (this.$i18n.locale === 'en') {
                return Object.assign({ value: item.value, text: item.text_en + ' (Roll-' + item.student_id + ')' })
            } else {
                return Object.assign({ value: item.value, text: item.text_bn + ' (রোল-' + this.$n(item.student_id, { useGrouping: false }) + ')' })
            }
        })
    },
    view (item) {
        this.item = item
        this.viewitemId = item.id
    },
    searchData () {
        this.loadData()
    },
    loadData () {
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
        this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
        RestApi.getData(disabilitySchoolServiceBaseUrl, progressLetterListApi, params).then(response => {
            if (response.success) {
                this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                this.paginationData(response.data)
            }
            this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
        })
    },
    getRelationalData (data) {
        let tmpOrganization = {}
        let tmpInstituteType = {}
        let tmpInstitute = {}
        const listData = data.map(item => {
                tmpOrganization = this.$store.state.commonObj.organizationProfileList.find(organization => organization.value === item.org_id)
                tmpInstituteType = this.$store.state.commonObj.officeTypeList.find(institute => institute.value === item.office_type_id)
                tmpInstitute = this.$store.state.commonObj.officeList.find(institute => institute.value === item.office_id)
                const tmpSlot = this.$store.state.DisabilitySchoolService.commonObj.IepSlotList.find(slot => slot.value === item.iep_slot_id)
                const tmpClass = this.$store.state.DisabilitySchoolService.commonObj.classList.find(el => el.value === parseInt(item.class_id))
                // const tmpExam = this.$store.state.DisabilitySchoolService.commonObj.examTypeList.find(el => el.value === parseInt(item.exam_type_id))
                const returnData = {
                    organization_name_bn: tmpOrganization !== undefined ? tmpOrganization.text_bn : '',
                    organization_name: tmpOrganization !== undefined ? tmpOrganization.text_en : '',
                    institute_type_name_bn: tmpInstituteType !== undefined ? tmpInstituteType.text_bn : '',
                    institute_type_name: tmpInstituteType !== undefined ? tmpInstituteType.text_en : '',
                    institute_name_bn: tmpInstitute !== undefined ? tmpInstitute.text_bn : '',
                    institute_name: tmpInstitute !== undefined ? tmpInstitute.text_en : '',
                    class_name: tmpClass !== undefined ? tmpClass.text_en : '',
                    class_name_bn: tmpClass !== undefined ? tmpClass.text_bn : '',
                    slot_bn: tmpSlot !== undefined ? tmpSlot.text_bn : '',
                    slot_en: tmpSlot !== undefined ? tmpSlot.text_en : ''
                    // exam_name: tmpExam !== undefined ? tmpExam.text_en : '',
                    // exam_name_bn: tmpExam !== undefined ? tmpExam.text_bn : ''
                }
                return Object.assign({}, item, returnData)
            })
            return listData
        },
        getOfficeTypeList () {
            this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id).map(obj => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getOfficeList () {
            this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
  }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
